"use client"
import CartProductList from '@/components/cart/cart-product-list'
import CartSummary from '@/components/cart/cart-summary'
import MaxWidthWrapper from '@/components/common/max-width-wrapper'
import { useCart } from '@/hooks/use-cart'
import { cn } from '@/lib/utils'

const CartPage = () => {
  const items = useCart((state) => state.items)
  const cartTotal = items.reduce((total, { product, quantity=1 }) => Number(product.price) * quantity + total, 0)

  return (
    <div className='bg-slate-50 pt-24 pb-16 lg:pt-28 lg:pb-20'>
      <MaxWidthWrapper>
        <div>
          <h1 className='text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
            Shopping Cart
          </h1>

          <div className='mt-6 lg:mt-12 lg:grid lg:grid-cols-12 lg:items-start lg:gap-x-12 xl:gap-x-16'>
            <div className={cn("lg:col-span-7")}>

              <h2 className='sr-only'>
                Items in your shopping cart
              </h2>
              <CartProductList items={items}  />
             </div>
            <section className='mt-10 rounded-lg lg:col-span-5 lg:mt-0'>
              <CartSummary cartTotal={cartTotal} />
            </section>
          </div>
        </div>
      </MaxWidthWrapper>
    </div>
  )
}

export default CartPage